import { FaComments, FaClipboardList, FaTools, FaBolt, FaShieldAlt, FaHeadset } from 'react-icons/fa';
import { images } from '../constants';

const process = [
  {
    id: 1,
    image: images.step1,
    icon: <FaComments />,
    title: 'Service Consultation',
    content: 'We start with a personalized consultation to understand your connectivity needs and recommend the best packages.',
  },
  {
    id: 2,
    image: images.step2,
    icon: <FaClipboardList />,
    title: 'Plan Selection',
    content: 'Choose from a variety of high-speed internet, cable, and phone packages that suit your household or business needs.',
  },
  {
    id: 3,
    image: images.step3,
    icon: <FaTools />,
    title: 'Equipment Installation',
    content: 'Our team will set up your modem, router, and any additional equipment to ensure a seamless connection.',
  },
  {
    id: 4,
    image: images.step4,
    icon: <FaBolt />,
    title: 'Connection Activation',
    content: 'We activate your services quickly so you can start enjoying high-speed internet, crystal-clear TV, and reliable phone service right away.',
  },
  {
    id: 5,
    image: images.step5,
    icon: <FaShieldAlt />,
    title: 'Quality Assurance',
    content: 'Our technicians perform quality checks to ensure that you receive the best possible service and performance.',
  },
  {
    id: 6,
    image: images.step6,
    icon: <FaHeadset />,
    title: 'Ongoing Support',
    content: 'Our customer support team is always available to assist with any questions or technical support you may need.',
  },
];

export default process;